import { render, staticRenderFns } from "./StatsConfig.vue?vue&type=template&id=27bf01c6"
import script from "./StatsConfig.vue?vue&type=script&lang=js"
export * from "./StatsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports